module.exports = __webpack_public_path__ + "static/media/Rubik-Light.843bf583.eot";